import { ReactElement, useEffect, useState } from 'react';

import { BannerImage } from '../components/BannerImage';
import { HirePlanFormSection } from '../components/HirePlanForm/Functionary-steps/HirePlanFormSection';
import { HirePlanMobileArticleHeader } from '../components/HirePlanForm/mobile/HirePlanMobileArticleHeader';
import { PageHelmet } from '../components/PageHelmet';
import { useWindowSizeStore } from '../stores/useWindowSizeStore';
import {
  json,
  useLoaderData,
  useParams,
  useRouteLoaderData,
} from 'react-router-dom';
import { useBoostedPlanDataStore } from '../stores/useBoostedPlanDataStore';
import { useNortheastPlanDataStore } from '../stores/useNortheastPlanDataStore';
import { EmpresaSummary } from '../components/HirePlanForm/DadosEmpresa';

export function IncludeFunctionary(): ReactElement {
  return (
    <div className="overflow-hidden">
      <PageHelmet title="Incluir Funcionário | OdontoGroup" />

      <BannerImage page="plan" imgSource="/assets/images/plan-banner.jpg" />
      <div className="">
        <article className="-mb-20 bg-transparent min-[748px]:-mt-[326px] -mt-[57px] max-w-[1551px] max-[1599px]:px-6 mx-auto">
          <div className="flex 2xl:gap-16 min-[748px]:gap-8 gap-16 max-[1085px]:flex-col">
            <HirePlanMobileArticleHeader />
            <EmpresaSummary key="purchaseSummary" />,
            <HirePlanFormSection key="hirePlanFormSection" />,
          </div>
        </article>
      </div>
    </div>
  );
}
